import { Section } from '../../../../models/section';

export class StepperModels {
  public id: number;
  public value: number;
  public prefix?: string;
  public libelle: string;
  public required: boolean;
  public sections: Section[];
  public repeatable: boolean;
  public eformName: string;

  constructor() {
    this.sections = [];
  }
}
